import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchFaqEntryByIdRequest = createAction("".concat(stateName, "/fetchFaqEntryByIdRequest"));
export const fetchFaqEntryByTypeRequest = createAction("".concat(stateName, "/fetchFaqEntryByTypeRequest"));